import React, { useContext, useEffect, useState } from 'react';

import { ClientContext, LanguageContext } from 'providers';
import announcementService from 'services/api/announcementService';
import { isHZMN446Enabled } from 'featureFlags';
import NotificationBox from '../NotificationBox/NotificationBox';

const LoginPageAnnouncement = () => {
    const { features, organizationId } = useContext(ClientContext);
    const { language } = useContext(LanguageContext);
    const lcId = language?.lcId || 'en_US';
    const isClientMigrated = features?.isClientMigrated === true;
    const showAnnouncement = isClientMigrated && isHZMN446Enabled();
    const [message, setMessage] = useState('');

    useEffect(() => {
        let active = true;

        setMessage('');

        if (showAnnouncement) {
            announcementService.getLoginPage({ language: { lcId }, organizationId }).then(
                (announcement) => {
                    if (active) {
                        setMessage(announcement?.message || '');
                    }
                },
                () => {
                    if (active) {
                        setMessage('');
                    }
                }
            );
        }

        return () => {
            active = false;
        };
    }, [showAnnouncement, lcId, organizationId]);

    if (!showAnnouncement || !message.trim()) {
        return null;
    }

    return (
        <div role="alert" className="text-overflow-break-word" style={{ whiteSpace: 'pre-wrap' }}>
            <NotificationBox variant="danger" message={message} />
        </div>
    );
};

export default LoginPageAnnouncement;
